export const constHeaders = [
  ["", "System", "Producentów", "500Hz", "1000Hz", "2000Hz", "4000Hz"],
  ["", "Producent", "Marek", "500Hz", "1000Hz", "2000Hz", "4000Hz"],
  ["", "Marka", "Modeli", "500Hz", "1000Hz", "2000Hz", "4000Hz"],
  [
    "",
    "Producent",
    "Model",
    "Kalibracji",
    "500Hz",
    "1000Hz",
    "2000Hz",
    "4000Hz",
  ],
];
